import { IconButton } from "@mui/material";
import React from "react";
import { useAppHeaderOptionsStyles } from "../styles";
import clsx from "clsx";
import { ComponentWithChildren } from "../../../../common/types";

type Props = {
  onIconClick: () => void;
  isActive: boolean;
  title: string;
  disabled?: boolean;
  dataTestId?: string;
};

export const AppHeaderOptionItem: ComponentWithChildren<Props> = ({ dataTestId, children, disabled, onIconClick, isActive, title }) => {
  const classes = useAppHeaderOptionsStyles();

  return (
    <div className={clsx(classes.optionContainer, !disabled && classes.optionContainerHover)}>
      <IconButton data-testid={dataTestId} sx={{ mr: 1 }} onClick={onIconClick} disableRipple disabled={disabled} className={classes.iconButton}>
        <div className={clsx(classes.buttonContainer, isActive && classes.activeButtonContainer)}>
          {children}
          <span className={clsx(classes.buttonTitle, isActive && classes.activeButtonTitle, disabled && classes.disabledButtonTitle)}>
            {title}
          </span>
        </div>
      </IconButton>
      {isActive && <hr className={classes.bottomLine} />}
    </div>
  );
};
